import React from "react";
import styles from "./UtilityCard.module.scss";
import Button from "../button/Button";

interface UtilityCardProps {
	logo: string;
	name: string;
	onManage: () => void;
	alt?: string;
	description?: string;
}

const UtilityCard: React.FC<UtilityCardProps> = ({ logo, name, onManage, description, alt = name }) => {
	return (
		<div className={styles.card}>
			<div className={styles.logoContainer}>
				<img src={logo} alt={alt} className={styles.logo} />
			</div>
			<div className={styles.lowerSection}>
				<div className={styles.nameContainer}>
					<h3 className={styles.name}>{name}</h3>
					<p className={styles.description}>{description}</p>
				</div>
				<div className={styles.actions}>
					<Button text="Manage" variant="outline" onClick={onManage} className={styles.manageButton} />
				</div>
			</div>
		</div>
	);
};

export default UtilityCard;
